<template>
  <v-footer padless>
    <v-card flat tile class="teal darklen-3" width="100%">
      <div class="text-center">
        <v-btn
          v-for="link in links"
          :key="link"
          color="white"
          text
          rounded
          class="my-2 font-weight-black text-body-2 text-sm-body-1"
        >
          <a :href="'/' + link.link" class="white--text text-decoration-none">
            {{ link.name }}
          </a>
        </v-btn>
      </div>
      <v-card-text class="text-center white--text font-weight-black">
        <div>
          <a href="/privacy.html" class="white--text text-decoration-none">
            プライバシーポリシー
          </a>
        </div>
        <a class="white--text text-decoration-none" href="https://www.rrr.or.jp" target="_blank" rel="noopener">
          運営幹事団体：一般社団法人地域資源循環システム協会
        </a>
        <div>
          <a class="white--text text-decoration-none" href="https://www.enerbank.co.jp" target="_blank" rel="noopener">
            運営支援会社：株式会社エナーバンク
          </a>
        </div>
      </v-card-text>
      <v-card-text class="text-center white--text font-weight-black">
        ©2020 地域資源循環システム協会
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      links: [
        {
          name: 'エネルギーオークションとは',
          link: '#what',
        },
        {
          name: '削減事例',
          link: '#example',
        },
        {
          name: '利用方法',
          link: '#howto',
        },
        {
          name: '特徴',
          link: '#feature',
        },
        {
          name: 'その他サービス',
          link: '#other',
        },
        {
          name: 'よくある質問',
          link: '#qa',
        },
      ],
    }
  },
}
</script>

<style></style>
